var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoFavorisSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictos",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.2,24.8c-.6-1.8-2.1-3.1-3.9-3.2l-9.9-1.6-4.5-9.5c-.8-1.8-2.6-2.8-4.4-2.8-2,0-3.6,1.2-4.4,2.8l-4.5,9.5-9.9,1.4c-1.8.4-3.4,1.6-3.9,3.2-.6,1.6-.2,3.7,1.2,5l7.3,7.5-1.8,10.7c-.4,2,.4,3.7,2,4.9.8.6,1.8,1,2.8,1,.8,0,1.6-.2,2.4-.6l8.9-4.9,8.9,4.9c.6.4,1.4.6,2.4.6s2-.4,2.8-.8c1.4-1.2,2.2-2.9,2-4.9l-1.8-10.7,7.3-7.5c1.2-1.3,1.6-3.2,1-5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoFavorisSolid);
export default __webpack_public_path__ + "static/media/picto-favoris-solid.c2a31b25a6fcb6190accbfda079d10ef.svg";
export { ForwardRef as ReactComponent };